namespace AgerLMS.LMS {
    export interface DiscountUsersRow {
        Id?: number;
        DiscountId?: number;
        UserId?: number;
        DiscountTitle?: string;
        DiscountDiscountType?: number;
        DiscountSource?: number;
        DiscountProductType?: number;
        DiscountGroups?: string;
        DiscountPercentage?: number;
        DiscountMaxAmount?: number;
        DiscountMinimumOrder?: number;
        DiscountUsableTimes?: number;
        DiscountCoupon?: string;
        DiscountExpiryDate?: string;
        DiscountOnlyFirst?: number[];
        DiscountInsertDate?: string;
        DiscountInsertUserId?: number;
        DiscountUpdateDate?: string;
        DiscountUpdateUserId?: number;
        DiscountIsActive?: number;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: number[];
        UserTwoFactorAuth?: number;
        UserBio?: string;
        UserJobTitle?: string;
        UserProfileImage?: string;
        UserProfileCover?: string;
        UserEnableProfileMessages?: number[];
        UserUserGroup?: number;
        UserZoomApi?: string;
        UserGender?: number;
        UserTcNo?: string;
    }

    export namespace DiscountUsersRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'LMS.DiscountUsers';
        export const deletePermission = '?';
        export const insertPermission = '?';
        export const readPermission = '?';
        export const updatePermission = '?';

        export declare const enum Fields {
            Id = "Id",
            DiscountId = "DiscountId",
            UserId = "UserId",
            DiscountTitle = "DiscountTitle",
            DiscountDiscountType = "DiscountDiscountType",
            DiscountSource = "DiscountSource",
            DiscountProductType = "DiscountProductType",
            DiscountGroups = "DiscountGroups",
            DiscountPercentage = "DiscountPercentage",
            DiscountMaxAmount = "DiscountMaxAmount",
            DiscountMinimumOrder = "DiscountMinimumOrder",
            DiscountUsableTimes = "DiscountUsableTimes",
            DiscountCoupon = "DiscountCoupon",
            DiscountExpiryDate = "DiscountExpiryDate",
            DiscountOnlyFirst = "DiscountOnlyFirst",
            DiscountInsertDate = "DiscountInsertDate",
            DiscountInsertUserId = "DiscountInsertUserId",
            DiscountUpdateDate = "DiscountUpdateDate",
            DiscountUpdateUserId = "DiscountUpdateUserId",
            DiscountIsActive = "DiscountIsActive",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            UserBio = "UserBio",
            UserJobTitle = "UserJobTitle",
            UserProfileImage = "UserProfileImage",
            UserProfileCover = "UserProfileCover",
            UserEnableProfileMessages = "UserEnableProfileMessages",
            UserUserGroup = "UserUserGroup",
            UserZoomApi = "UserZoomApi",
            UserGender = "UserGender",
            UserTcNo = "UserTcNo"
        }
    }
}
